import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.loadTabs();
    }

    loadTabs() {
        const tabs = document.querySelectorAll('.tab-container .tab');

        if (tabs.length > 0) {
            for (const tab of tabs) {
                tab.addEventListener('click', (e) => {
                    this.removeActive();

                    e.target.classList.add('active');

                    const target = document.querySelector(e.target.dataset.target);
                    if (target) {
                        target.classList.add('active');
                    }
                });
            }
        }
    }

    removeActive() {
        const tabs = document.querySelectorAll('.tab-container .tab.active');
        if (tabs.length > 0) {
            for (const tab of tabs) {
                tab.classList.remove('active');
            }
        }

        const contents = document.querySelectorAll('.tab-contents .tab-content.active');
        if (contents.length > 0) {
            for (const content of contents) {
                content.classList.remove('active');
            }
        }
    }
}
